"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isString(maybe) {
    return typeof maybe === 'string';
}
exports.default = isString;
